var module = angular.module("app");
//module.constant("restUrlPrefix", "api/v1/");
//module.constant("restUrlPrefixInternal", "api/");
module.constant("restUrlPrivatePrefix", "api/v1/private/");
module.constant("restUrlPublicPrefix", "api/v1/public/");
module.constant("websocketEndpoint", "/api/v1/classification");
module.constant("smartTableStringColumnLimit", "128");